import { Stack, Typography } from "@mui/material";
import React from "react";

const Warning = ({ message }) => {
  return (
    <Stack width={"25rem"} rowGap={"1.5rem"}>
      <Typography variant="h2" color={"primary"}>
        Warning
      </Typography>
      <Typography variant="body1" color={"textSecondary"}>
        {message}
      </Typography>
    </Stack>
  );
};

export default Warning;
